import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "startsAtDateUtc",
    "startsAtMessage",
    "startsImmediately",
  ]

  static values = {
    unauthorizedTooltip: {
      type: String,
      default: "Unauthorized rules cannot be scheduled and must start immediately."
    }
  }

  hasValidValue() {
    return this.startsImmediatelyTarget.checked || !!this.startsAtDateUtcTarget.value
  }

  enableFields() {
    this.element.classList.remove("disabled")
    this.startsImmediatelyTarget.disabled = false
  }

  disableFields() {
    this.element.classList.add("disabled")
    this.startsImmediatelyTarget.checked = true
    this.startsImmediatelyTarget.disabled = true
    this.#clearAndLockDateField()
  }

  showTooltip() {
    this.startsAtDateUtcTarget.setAttribute("data-original-title", this.unauthorizedTooltipValue)
  }

  hideTooltip() {
    this.startsAtDateUtcTarget.setAttribute("data-original-title", "")
  }

  toggleStartsImmediately(event) {
    if (event.target.checked) {
      this.#clearAndLockDateField()
    } else {
      this.#unlockDateField()
    }
  }

  // `readOnly`, not `disabled`, because we need to submit the form with the
  // `null` value. (`disabled` would result in the input value not being
  // submitted at all.)
  #clearAndLockDateField() {
    this.startsAtDateUtcTarget.value = null
    this.startsAtMessageTarget.classList.add("hidden")
    this.startsAtDateUtcTarget.readOnly = true
  }

  #unlockDateField() {
    this.startsAtDateUtcTarget.readOnly = false
    this.startsAtMessageTarget.classList.remove("hidden")
  }
}
